export function formatCurrency(
  number: number | Intl.StringNumericLiteral,
  currencyAlphaCode?: string,
) {
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...(currencyAlphaCode && { style: 'currency', currency: currencyAlphaCode }),
  }).format(number);
}
